import { Toggle } from '@augmentt-dev/ui-components'
import PropTypes from 'prop-types'
import React from 'react'
import { Form } from 'react-bootstrap'
import styles from './CustomizeAuditModal.module.scss'

const propTypes = {
  /**
   * The customer level setting
   */
  setting: PropTypes.object, // eslint-disable-line react/forbid-prop-types
  /**
   * The organization level setting
   */
  orgSetting: PropTypes.object, // eslint-disable-line react/forbid-prop-types
  /**
   * Callback to set the value changed
   */
  onChange: PropTypes.func.isRequired,
}

function CompanySettingSelector(props) {
  const { setting = {}, orgSetting = {}, onChange } = props ?? {}

  return (
    <div className="d-flex text-color-default">
      <div className={styles.toggleWrapper}>
        <Toggle
          id={`${setting.name}-toggle`}
          checked={setting.inherit ? orgSetting.enabled : setting.enabled}
          onChange={(checked) => onChange({ ...setting, enabled: checked, inherit: false })}
        />
      </div>
      <Form.Check
        custom
        type="checkbox"
        id={`${setting.name}-inherit-checkbox`}
        className={styles.inheritCheckbox}
        checked={setting.inherit}
        onChange={(event) => onChange({ ...setting, enabled: orgSetting.enabled, inherit: event.target.checked })}
        label="Inherit"
      />
    </div>
  )
}

CompanySettingSelector.propTypes = propTypes

export default CompanySettingSelector
